<template>
  <div>
    <figure class="highcharts-figure">
      <highcharts ref="chart" :options="options" />
      <p class="highcharts-description highcharts-linked-description">
        <strong>Figure : </strong>
        {{ $t('compGraphicsEnergyPerformance.help1') }}
      </p>
    </figure>
    <br />
    <figure class="highcharts-figure">
      <b-table
        :data="ghgi.buildings.toArray()"
        :striped="true"
        :narrowed="true"
      >
        <b-table-column
          :label="$t('compGraphicsEnergyPerformance.label-8')"
          v-slot="props"
        >
          <span
            class="tag"
            :class="classBuilding(props.row.getEnergeticValues()[0])"
          >
            {{ props.row.getEnergeticValues()[0] }}
          </span>
        </b-table-column>
        <b-table-column
          :label="$t('compGraphicsEnergyPerformance.label-6')"
          sticky
          v-slot="props"
        >
          {{ props.row.name }}
        </b-table-column>
        <b-table-column
          :label="$t('compGraphicsEnergyPerformance.label-10')"
          numeric
          v-slot="props"
        >
          {{ Math.round(props.row.getEnergeticValues()[1]) | splitNumber }}
        </b-table-column>
        <b-table-column
          :label="$t('compGraphicsEnergyPerformance.label-11')"
          numeric
          v-slot="props"
        >
          {{ Math.round(props.row.getEnergeticValues()[3]) | splitNumber }}
        </b-table-column>
      </b-table>
      <br />
      <p class="highcharts-description highcharts-linked-description">
        <strong>Table : </strong>
        {{ $t('compGraphicsEnergyPerformance.help2') }}
      </p>
    </figure>
  </div>
</template>

<script>
import Building from '@/models/carbon/Building.js'
import '@/plugins/highcharts.js'

export default {
  name: 'EnergyPerformance',
  props: {
    ghgi: {
      type: Object,
      default: null
    }
  },
  data () {
    return {
      options: {}
    }
  },
  methods: {
    classBuilding (eclass) {
      return {
        ['is-' + eclass]: true
      }
    },
    compute () {
      let evalues = Building.getEnergeticValues(
        this.ghgi.buildings,
        this.ghgi.year
      )
      let eclass = Building.ENERGETIC_CLASSES.indexOf(evalues[0])
      let eperformance = evalues[1]
      let iperformance = evalues[3]
      let self = this
      this.options = {
        chart: {
          backgroundColor: 'white',
          events: {
            render: function () {
              let ren = this.renderer
              let values = [
                '≤ 70',
                '71 - 110',
                '111 - 180',
                '181 - 250',
                '251 - 330',
                '331 - 420',
                '≥ 420'
              ]
              let colors = [
                '#00af7b',
                '#48ba62',
                '#99ce7e',
                '#efea2e',
                '#f1b321',
                '#f0853c',
                '#dd2527'
              ]
              let delta = 30
              let middelta = delta / 2
              let length = 100
              let xtranslate = (this.chartWidth - 550) / 2
              let ytranslate = (this.chartHeight - 320) / 2
              let infoboxSize = delta * 7
              let aftercurrent = 0
              // create energetic arrows
              for (let index in Building.ENERGETIC_CLASSES) {
                let strokeSize = 0
                let xarrow = middelta + length + index * delta
                let yarrow = middelta
                let xlow = length + index * delta
                let ylow = delta
                let textsize = '25px'
                let ytext = 44
                let valuesize = '15px'
                let yvalue = 40
                if (parseInt(index) === eclass) {
                  strokeSize = 2
                  xarrow = middelta * 2 + length + index * delta
                  yarrow = middelta * 2
                  xlow = length + index * delta
                  ylow = delta * 2
                  textsize = '45px'
                  valuesize = '20px'
                  ytext = 65
                  yvalue = 55
                }
                ren
                  .path([
                    'M',
                    0,
                    0,
                    'L',
                    length + index * delta,
                    0,
                    'L',
                    xarrow,
                    yarrow,
                    'L',
                    xlow,
                    ylow,
                    'L',
                    0,
                    ylow,
                    'L',
                    0,
                    0
                  ])
                  .attr({
                    fill: colors[index],
                    'stroke-width': strokeSize,
                    stroke: '#000000'
                  })
                  .translate(
                    xtranslate + infoboxSize,
                    ytranslate + 20 + aftercurrent * delta + index * (delta + 5)
                  )
                  .add()
                ren
                  .text(values[index])
                  .css({
                    color: '#ffffff',
                    'font-size': valuesize,
                    'font-weight': 'bold'
                  })
                  .translate(
                    xtranslate + infoboxSize + 45,
                    ytranslate +
                      yvalue +
                      aftercurrent * delta +
                      index * (delta + 5)
                  )
                  .add()
                ren
                  .text(Building.ENERGETIC_CLASSES[index])
                  .css({
                    color: '#ffffff',
                    'font-size': textsize,
                    'font-weight': 'bold'
                  })
                  .translate(
                    xtranslate + infoboxSize + 5,
                    ytranslate +
                      ytext +
                      aftercurrent * delta +
                      index * (delta + 5)
                  )
                  .add()
                if (parseInt(index) === eclass) {
                  aftercurrent = 1
                }
              }
              // create texts
              ren
                .text(self.$t('compGraphicsEnergyPerformance.label-1'))
                .css({
                  color: '#00af7b',
                  'font-size': '14px',
                  'font-weight': 'bold'
                })
                .translate(xtranslate + infoboxSize, ytranslate + 15)
                .add()
              ren
                .text(self.$t('compGraphicsEnergyPerformance.label-2'))
                .css({
                  color: '#dd2527',
                  'font-size': '14px',
                  'font-weight': 'bold'
                })
                .translate(xtranslate + infoboxSize, ytranslate + 305)
                .add()
              ren
                .text(self.$t('compGraphicsEnergyPerformance.label-3'))
                .css({
                  color: '#000000',
                  'font-size': '14px',
                  'font-weight': 'bold'
                })
                .translate(
                  xtranslate + 120,
                  ytranslate + middelta - 5 + eclass * (5 + delta)
                )
                .add()
              ren
                .text(self.$t('compGraphicsEnergyPerformance.label-4'))
                .css({
                  color: '#000000',
                  'font-size': '14px',
                  'font-weight': 'bold'
                })
                .translate(
                  xtranslate,
                  ytranslate + middelta - 20 + eclass * (5 + delta)
                )
                .add()
              ren
                .text(self.$t('compGraphicsEnergyPerformance.label-5'))
                .css({
                  color: '#a3a3a3',
                  'font-size': '11px',
                  'font-weight': 'bold'
                })
                .translate(
                  xtranslate,
                  ytranslate + middelta - 5 + eclass * (5 + delta)
                )
                .add()
              // create ghgi and consumptions squares
              ren
                .path([
                  'M',
                  0,
                  0,
                  'L',
                  infoboxSize,
                  0,
                  'L',
                  infoboxSize,
                  delta * 2,
                  'L',
                  0,
                  delta * 2,
                  'L',
                  0,
                  0
                ])
                .attr({
                  'stroke-width': 2,
                  stroke: '#000000'
                })
                .translate(
                  xtranslate,
                  ytranslate + middelta + 5 + eclass * (5 + delta)
                )
                .add()
              ren
                .path(['M', 0, 0, 'L', 0, delta * 1.6])
                .attr({
                  'stroke-width': 2,
                  stroke: '#000000'
                })
                .translate(
                  xtranslate + infoboxSize / 2,
                  ytranslate + middelta + 10 + eclass * (5 + delta)
                )
                .add()
              let xiperformance =
                160 - 10 * Math.round(iperformance).toString().length
              ren
                .text(Math.round(iperformance))
                .css({
                  color: '#000000',
                  'font-size': '30px',
                  'font-weight': 'bold'
                })
                .translate(
                  xtranslate + xiperformance,
                  ytranslate + middelta + 40 + eclass * (5 + delta)
                )
                .add()
              ren
                .text(self.$t('compGraphicsEnergyPerformance.kg.co2e.year'))
                .css({
                  color: '#000000',
                  'font-size': '11px',
                  'font-weight': 'bold'
                })
                .translate(
                  xtranslate + 115,
                  ytranslate + middelta + 55 + eclass * (5 + delta)
                )
                .add()
              let xeperformance =
                55 - 10 * Math.round(eperformance).toString().length
              ren
                .text(Math.round(eperformance))
                .css({
                  color: '#000000',
                  'font-size': '30px',
                  'font-weight': 'bold'
                })
                .translate(
                  xtranslate + xeperformance,
                  ytranslate + middelta + 40 + eclass * (5 + delta)
                )
                .add()
              ren
                .text(self.$t('compGraphicsEnergyPerformance.kwh.m2.year'))
                .css({
                  color: '#000000',
                  'font-size': '11px',
                  'font-weight': 'bold'
                })
                .translate(
                  xtranslate + 20,
                  ytranslate + middelta + 55 + eclass * (5 + delta)
                )
                .add()
            }
          }
        },
        title: {
          verticalAlign: 'middle',
          floating: true,
          text: ''
        },
        legend: {
          enabled: false
        }
      }
    }
  },
  mounted () {
    this.compute()
  }
}
</script>

<style scoped>
.highcharts-figure {
  min-width: 320px;
  max-width: 700px;
  margin: 1em auto;
}
.highcharts-description {
  text-align: center;
  color: '#777777';
  font-style: italic;
}
</style>

<style>
.is-sticky {
  background: #fafafa !important;
}
.tag:not(body).is-A {
  background-color: #00af7b;
  color: #fff;
}
.tag:not(body).is-B {
  background-color: #48ba62;
  color: #fff;
}
.tag:not(body).is-C {
  background-color: #99ce7e;
  color: #fff;
}
.tag:not(body).is-D {
  background-color: #efea2e;
  color: #fff;
}
.tag:not(body).is-E {
  background-color: #f1b321;
  color: #fff;
}
.tag:not(body).is-F {
  background-color: #f0853c;
  color: #fff;
}
.tag:not(body).is-G {
  background-color: #dd2527;
  color: #fff;
}
</style>
